"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var leave_popup_component_1 = require("../leave-popup/leave-popup.component");
var constants_1 = require("../../utilities/constants");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var models_1 = require("../../models");
var utils_1 = require("../../utilities/utils");
var timer_1 = require("rxjs/observable/timer");
var VcRoomBase = /** @class */ (function () {
    function VcRoomBase(vcCmsService, dialog, webRTC, vcService, networkService) {
        this.vcCmsService = vcCmsService;
        this.dialog = dialog;
        this.webRTC = webRTC;
        this.vcService = vcService;
        this.networkService = networkService;
        this.isSubscriber = false;
        this.leave = new core_1.EventEmitter();
        this.end = new core_1.EventEmitter();
        this.block = new core_1.EventEmitter();
        this.speakerMode = true;
        this.allParticipants = [];
        this.staffParticipants = [];
        this.isHummerPunched = false;
        // todo refactoring dummy solutions
        this.vcParticipantsRoleMapping = new Map();
        this.CHAT_TAB = 0;
        this.PARTICIPANT_TAB = 1;
        this.chatMessages = [];
        this.staffParticipantsTotalPages = 1;
        // to hide current speaker in staff line
        this.staffParticipantsPagingStartIndex = 0;
        this.participantsCurrentPage = 0;
        this.allParticipantsTotalPages = 1;
        // to hide current speaker in participant line
        this.participantsPagingStartIndex = 0;
        this.isSessionStartedByMe = false;
        this.selectedTabIndex = 0;
        this.unreadMessagesCount = 0;
        this.benchMemberCurrentPage = 0;
        this.benchMemberParticipantsTotalPage = 1;
        this.benchMemberParticipantsPagingStartIndex = 0;
        this.BENCH_MEMBER_PARTICIPANTS_PER_PAGE = 6;
        this.courtStaffCurrentPage = 0;
        this.courtStaffParticipantsTotalPage = 1;
        this.courtStaffParticipantsPagingStartIndex = 0;
        this.COURT_STAFF_PARTICIPANTS_PER_PAGE = 6;
        this.otherParticipantCurrentPage = 0;
        this.otherParticipantsTotalPage = 1;
        this.otherParticipantsPagingStartIndex = 0;
        this.OTHER_PARTICIPANTS_PER_PAGE = 12;
        this.courtStaffParticipants = [];
        this.benchMemberParticipants = [];
        this.otherParticipants = [];
        this.filteredParticipantsInSpeakerMode = [];
        this.VC_ACTIONS = models_1.VC_ACTIONS;
        this.currentFilter = models_1.PARTICIPANTS_FILTER.ALL;
        this.isGavelDisabled = false;
        this.destroy$ = new Subject_1.Subject();
    }
    VcRoomBase.prototype.ngOnInit = function () {
        this.isSubscriber && this.webRTC.initialize(this.sessionId);
        this.account = this.webRTC.getAccount();
        this.subscribeToConnection();
        this.subscribeToDisconnection();
        this.subscribeToStreamCreation();
        this.subscribeToStreamDeletion();
        this.subscribeToStreamChanges();
        this.subscribeToPublisherStartSpeakingEvent();
        this.subscribeToPublisherStopSpeakingEvent();
        this.subscribeToChatEvents();
        this.subscribeToBlockEvents();
        this.subscribeToMuteEvents();
        this.subscribeToVideoOnEvents();
        this.joinToSession();
        this.vcService.onRefresh(this.mediaStream);
    };
    VcRoomBase.prototype.ngOnDestroy = function () {
        this.vcService.clearStream(this.mediaStream);
        this.destroy$.next();
        this.destroy$.complete();
    };
    VcRoomBase.prototype.joinToSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var connectionData, currentUserData, _a, createdAt;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isSessionStartedByMe = true;
                        return [4 /*yield*/, this.webRTC.joinToRoom(this.sessionId)];
                    case 1:
                        connectionData = _b.sent();
                        if (connectionData) {
                            if (!this.vcService.vcParticipants.size) {
                                this.vcParticipantsRoleMapping = this.vcService.parseParticipantsInfo(connectionData);
                            }
                            currentUserData = this.vcService.vcParticipants.get(connectionData.currentUserId);
                            this.vcService.roles = connectionData.roles;
                            if (currentUserData) {
                                this.account.name = currentUserData.name;
                                this.account.role = currentUserData.userRole || connectionData.roles[currentUserData.userRoleId];
                                this.account.isMain = currentUserData.isMain;
                                this.account.isStaff = currentUserData.isStaff;
                                this.account.activeAudio = false;
                            }
                        }
                        if (!!this.isSubscriber) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.vcService.publish(this.account)];
                    case 2:
                        _b.sent();
                        this.vcService.clearMediaStream(this.mediaStream);
                        _a = this;
                        return [4 /*yield*/, this.vcService.requestMediaStream(this.account)];
                    case 3:
                        _a.mediaStream = _b.sent();
                        // Temporary solution until sds version
                        document.querySelector("sds-tabs")
                            .shadowRoot.querySelector(".sds-tab-body-wrapper").setAttribute("style", "height: inherit");
                        return [3 /*break*/, 5];
                    case 4:
                        this.account.activeVideo = false;
                        _b.label = 5;
                    case 5: return [4 /*yield*/, this.networkService.getSessionStatus(this.sessionId)];
                    case 6:
                        createdAt = (_b.sent()).createdAt;
                        this.setRecordingTime(createdAt);
                        this.loadChatMessages();
                        return [2 /*return*/];
                }
            });
        });
    };
    VcRoomBase.prototype.toggleDevices = function (actionName, user) {
        if (actionName === models_1.VC_ACTIONS.MUTE_ALL || actionName === models_1.VC_ACTIONS.MUTE) {
            this.onMute(user);
        }
        else if (actionName === models_1.VC_ACTIONS.TURN_ON_VIDEO_ALL || actionName === models_1.VC_ACTIONS.TURN_ON_VIDEO) {
            this.onVideoOn(user);
        }
        else {
            this.onBlock(user);
        }
    };
    VcRoomBase.prototype.onScrollEvent = function () {
        if (this.selectedTabIndex === 0) {
            var hideArrow = Math.abs(Math.floor(this.commentSidebar.nativeElement.scrollTop + this.commentSidebar.nativeElement.clientHeight)
                - Math.floor(this.commentSidebar.nativeElement.scrollHeight)) <= 2;
            if (hideArrow) {
                // appears if new messages are available and scroll is fixed
                this.showScrollDownArrowIcon = false;
            }
        }
    };
    VcRoomBase.prototype.onMute = function (user) {
        this.webRTC.signal(user ? '' : 'broadcast', user ? [user.participant.connection] : [], 'mute');
    };
    VcRoomBase.prototype.onVideoOn = function (user) {
        this.webRTC.signal(user ? '' : 'broadcast', user ? [user.participant.connection] : [], 'videoOn');
    };
    VcRoomBase.prototype.toggleAudio = function () {
        this.account.toggleAudio();
    };
    VcRoomBase.prototype.openLeaveDialog = function () {
        var _this = this;
        var dialogRef = this.dialog.open(leave_popup_component_1.LeavePopupComponent, { width: '560px' });
        dialogRef.afterClosed()
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (result) {
            if (result) {
                _this.leave.emit();
            }
        });
    };
    VcRoomBase.prototype.sendMessage = function (event) {
        event.preventDefault();
        var message = this.message.trim();
        if (message.length) {
            this.vcService.sendMessage(message, this.sessionId);
            this.message = '';
        }
    };
    VcRoomBase.prototype.onBlock = function (user) {
        var _this = this;
        this.vcCmsService.blockUser(this.sessionId, user.USERID)
            .then(function () {
            _this.webRTC.signal(user.USERID.toString(), [], 'block');
        });
    };
    VcRoomBase.prototype.onFilterParticipantsInSpeakerMode = function (option) {
        this.currentFilter = option;
        this.filteredParticipantsInSpeakerMode = this._onFilterParticipantsInSpeakerMode(option);
    };
    VcRoomBase.prototype.toggleVideo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.account.toggleVideo();
                        return [4 /*yield*/, this.vcService.publish(this.account)];
                    case 1:
                        _b.sent();
                        this.vcService.clearMediaStream(this.mediaStream);
                        _a = this;
                        return [4 /*yield*/, this.vcService.requestMediaStream(this.account)];
                    case 2:
                        _a.mediaStream = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VcRoomBase.prototype.onTabChange = function (tabIndex) {
        this.showScrollDownArrowIcon = false;
        this.selectedTabIndex = tabIndex;
        if (this.selectedTabIndex === this.CHAT_TAB) {
            this.unreadMessagesCount = 0;
            this.commentSidebar.nativeElement.scrollTop = this.commentSidebar.nativeElement.scrollHeight;
        }
    };
    VcRoomBase.prototype.onScrollToBottom = function () {
        this.commentSidebar.nativeElement.scrollTop = this.commentSidebar.nativeElement.scrollHeight;
        this.showScrollDownArrowIcon = false;
    };
    VcRoomBase.prototype.setRecordingTime = function (createdAt) {
        var _this = this;
        timer_1.timer(utils_1.ONE_SECOND_IN_MS, utils_1.ONE_SECOND_IN_MS)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function () {
            _this.formattedRecordingDuration = utils_1.getTime(createdAt);
        });
    };
    VcRoomBase.prototype.loadChatMessages = function () {
        var _this = this;
        this.vcCmsService.getMessages(this.sessionId)
            .then(function (data) {
            _this.chatMessages = data.map(function (chatMessage) {
                return {
                    message: chatMessage.message,
                    createdBy: _this.vcService.vcParticipants.get(chatMessage.userId),
                    createdOn: chatMessage.timestamp
                };
            });
            _this.isNewMessageVisible = true;
        });
    };
    VcRoomBase.prototype.subscribeToConnection = function () {
        var _this = this;
        this.webRTC.on('connectionCreated', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var connectionData, participant, userInfo;
            return __generator(this, function (_a) {
                connectionData = JSON.parse(event.connection.data);
                // when connecting there are participants already
                if (!this.vcService.vcParticipants.size) {
                    this.vcParticipantsRoleMapping = this.vcService.parseParticipantsInfo(connectionData);
                }
                participant = new models_1.Participant(event.connection, this.vcService.vcParticipants.get(connectionData.currentUserId), this.vcService.roles);
                this.lastActiveParticipant = this._getLastActiveParticipantWhenConnectionCreated(participant, event);
                this._addParticipantToConference(participant, event);
                userInfo = this.vcService.getUserInfo(event.connection.data);
                userInfo.connected = true;
                userInfo.participant = participant;
                this.onFilterParticipantsInSpeakerMode(this.currentFilter);
                return [2 /*return*/];
            });
        }); });
    };
    VcRoomBase.prototype._getLastActiveParticipantWhenConnectionCreated = function (participant, event) {
        if (this.isSessionStartedByMe && !this.lastActiveParticipant) {
            return this.webRTC.isMyOwnConnection(event.connection) && participant;
        }
        else {
            if (!this.webRTC.isMyOwnConnection(event.connection) && !this.lastActiveParticipant) {
                return participant;
            }
        }
        return this.lastActiveParticipant;
    };
    VcRoomBase.prototype._addParticipantToConference = function (participant, event) {
        if (participant.isMain) {
            this.judge = participant;
            this.courtStaffParticipants = this.courtStaffParticipants.concat([participant]);
        }
        else if (!this.webRTC.isMyOwnConnection(event.connection)) {
            if (participant.isStaff) {
                this._addStaffParticipantToConference(participant);
            }
            else {
                this._addNoneStaffParticipantToConference(participant);
            }
        }
    };
    VcRoomBase.prototype._addStaffParticipantToConference = function (participant) {
        if (participant.isBenchMember) {
            this.benchMemberParticipants = this.benchMemberParticipants.concat([participant]);
            this.benchMemberParticipantsTotalPage = utils_1.calculateMemberTotalPage(this.benchMemberParticipants.length, this.benchMemberParticipantsPagingStartIndex, this.BENCH_MEMBER_PARTICIPANTS_PER_PAGE);
        }
        else {
            this.courtStaffParticipants = this.courtStaffParticipants.concat([participant]);
            this.courtStaffParticipantsTotalPage = utils_1.calculateMemberTotalPage(this.courtStaffParticipants.length, this.courtStaffParticipantsPagingStartIndex, this.COURT_STAFF_PARTICIPANTS_PER_PAGE);
        }
        this.staffParticipants = this.staffParticipants.concat([participant]);
        this.staffParticipantsPagingStartIndex = utils_1.getParticipantsPagingStartIndex(this.staffParticipants, this.lastActiveParticipant);
        this.staffParticipantsTotalPages = utils_1.calculateMemberTotalPage(this.staffParticipants.length, this.staffParticipantsPagingStartIndex, constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
    };
    VcRoomBase.prototype._addNoneStaffParticipantToConference = function (participant) {
        this.allParticipants = this.allParticipants.concat([participant]);
        if (!constants_1.AppConstants.isSubscriber(participant.connectionRole)) {
            this.otherParticipants.push(participant);
        }
        this.otherParticipantsTotalPage = utils_1.calculateMemberTotalPage(this.otherParticipants.length, this.otherParticipantsPagingStartIndex, this.OTHER_PARTICIPANTS_PER_PAGE);
        this.participantsPagingStartIndex = utils_1.getParticipantsPagingStartIndex(this.allParticipants, this.lastActiveParticipant);
        this.allParticipantsTotalPages = utils_1.calculateMemberTotalPage(this.allParticipants.length, this.participantsPagingStartIndex, constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
    };
    VcRoomBase.prototype.subscribeToDisconnection = function () {
        var _this = this;
        this.webRTC.on('connectionDestroyed', function (event) {
            var userInfo = _this.vcService.getUserInfo(event.connection.data);
            userInfo.connected = false;
            userInfo.participant = null;
            var filterParticipantsByConnectionId = function (participant) { return event.connection.connectionId !== participant.connection.connectionId; };
            var removeParticipantAndReCalculateParticipants = function (listName, participantsPerPage) {
                _this[listName + "Participants"] = _this[listName + "Participants"].filter(filterParticipantsByConnectionId);
                _this[listName + "ParticipantsTotalPage"] = utils_1.calculateMemberTotalPage(_this[listName + "Participants"].length, 0, participantsPerPage);
            };
            if (userInfo.isMain) {
                _this.judge = null;
                removeParticipantAndReCalculateParticipants('courtStaff', _this.COURT_STAFF_PARTICIPANTS_PER_PAGE);
            }
            else if (userInfo.isStaff) {
                if (userInfo.isBenchMember) {
                    removeParticipantAndReCalculateParticipants('benchMember', _this.BENCH_MEMBER_PARTICIPANTS_PER_PAGE);
                }
                else {
                    removeParticipantAndReCalculateParticipants('courtStaff', _this.COURT_STAFF_PARTICIPANTS_PER_PAGE);
                }
                removeParticipantAndReCalculateParticipants('staff', constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
            }
            else {
                removeParticipantAndReCalculateParticipants('other', _this.OTHER_PARTICIPANTS_PER_PAGE);
                removeParticipantAndReCalculateParticipants('all', constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
            }
            if (_this.lastActiveParticipant.connection.connectionId === event.connection.connectionId) {
                if (_this.lastActiveParticipant.isStaff && !_this.lastActiveParticipant.isMain) {
                    _this.staffParticipantsPagingStartIndex = 0;
                }
                else {
                    _this.participantsPagingStartIndex = 0;
                }
                // if speaker disconnects, set first staff participant, or participant as speaker or null if no one present
                if (_this.staffParticipants[0]) {
                    _this.lastActiveParticipant = _this.staffParticipants[0];
                    _this.staffParticipantsPagingStartIndex = 1;
                }
                else if (_this.allParticipants[0]) {
                    _this.lastActiveParticipant = _this.allParticipants[0];
                    _this.participantsPagingStartIndex = 1;
                }
                else {
                    _this.lastActiveParticipant = null;
                }
            }
            _this.onFilterParticipantsInSpeakerMode(_this.currentFilter);
            _this.checkParticipantsAudioVideo();
            // check and end session after 1 minute when there is no moderator
            setTimeout(function () { return _this.endSessionWhenNoModerator(); }, 60000);
        });
    };
    VcRoomBase.prototype.endSessionWhenNoModerator = function () {
        var isModeratorPresent = this.staffParticipants.some(function (participant) { return participant.isStaff; }) ||
            this.allParticipants.some(function (participant) { return participant.isStaff; }) || this.judge;
        if (!isModeratorPresent) {
            this.end.emit();
        }
    };
    VcRoomBase.prototype.subscribeToStreamCreation = function () {
        var _this = this;
        this.webRTC.on('streamCreated', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userInfo = this.vcService.getUserInfo(event.stream.connection.data);
                        return [4 /*yield*/, this.webRTC.startShowing(event.stream, this.findParticipantByConnectionId(userInfo, event.stream.connection))];
                    case 1:
                        _a.sent();
                        this.checkParticipantsAudioVideo();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    VcRoomBase.prototype.subscribeToStreamDeletion = function () {
        var _this = this;
        this.webRTC.on('streamDestroyed', function (event) {
            var userInfo = _this.vcService.getUserInfo(event.stream.connection.data);
            _this.webRTC.stopShowing(_this.findParticipantByConnectionId(userInfo, event.stream.connection));
        });
    };
    VcRoomBase.prototype.subscribeToStreamChanges = function () {
        var _this = this;
        this.webRTC.on('streamPropertyChanged', function (event) {
            if (event.changedProperty === 'videoActive' || event.changedProperty === 'audioActive') {
                _this.checkParticipantsAudioVideo();
            }
        });
    };
    /**
     * Check if someone's audio turned on or video turned off when stream is created, or someone disconnects or someone's stream property changes
     * @private
     */
    VcRoomBase.prototype.checkParticipantsAudioVideo = function () {
        var _a = this.vcService.checkParticipantsAudioVideo(this.staffParticipants, this.allParticipants, this.judge), isSomeoneUnMuted = _a.isSomeoneUnMuted, isSomeoneVideoOff = _a.isSomeoneVideoOff;
        this.isSomeoneUnmuted = isSomeoneUnMuted;
        this.isSomeoneVideoOff = isSomeoneVideoOff;
    };
    VcRoomBase.prototype.subscribeToPublisherStartSpeakingEvent = function () {
        var _this = this;
        this.webRTC.on('publisherStartSpeaking', function (event) {
            if (_this.webRTC.isMyOwnConnection(event.connection)) {
                _this.activeParticipant = _this.account;
            }
            else {
                var userInfo = _this.vcService.getUserInfo(event.connection.data);
                _this.activeParticipant = _this.findParticipantByConnectionId(userInfo, event.connection);
                _this.reorderSpeakers(_this.activeParticipant);
            }
            _this.activeParticipant.isSpeaking = true;
            // function call order matters, reset state and then reorder new state
            _this.setSpeakerViewData();
        });
    };
    VcRoomBase.prototype.subscribeToPublisherStopSpeakingEvent = function () {
        var _this = this;
        this.webRTC.on('publisherStopSpeaking', function (event) {
            if (!_this.webRTC.isMyOwnConnection(event.connection)) {
                var userInfo = _this.vcService.getUserInfo(event.connection.data);
                _this.findParticipantByConnectionId(userInfo, event.connection).isSpeaking = false;
            }
            else {
                _this.account.isSpeaking = false;
            }
        });
    };
    VcRoomBase.prototype.subscribeToChatEvents = function () {
        var _this = this;
        this.webRTC.on('signal:chat', function (event) {
            var userInfo = _this.vcService.getUserInfo(event.from.data);
            var data = JSON.parse(event.data);
            // scrolls to the last message if user didn't  scroll sidebar
            _this.isNewMessageVisible = Math.abs(Math.floor(_this.commentSidebar.nativeElement.scrollTop + _this.commentSidebar.nativeElement.clientHeight)
                - Math.floor(_this.commentSidebar.nativeElement.scrollHeight)) <= 2;
            if (!_this.isNewMessageVisible) {
                // appears if new messages are available and scroll is fixed
                _this.showScrollDownArrowIcon = true;
            }
            _this.chatMessages = _this.chatMessages.concat([{
                    message: data.message,
                    createdBy: userInfo,
                    createdOn: data.timestamp
                }]);
            _this.selectedTabIndex !== 0 && (_this.unreadMessagesCount++);
        });
    };
    VcRoomBase.prototype.subscribeToMuteEvents = function () {
        var _this = this;
        this.webRTC.on('signal:mute', function (event) {
            if (!_this.webRTC.isMyOwnConnection(event.from)) {
                if (event.data === 'broadcast') {
                    if (_this.account.activeAudio) {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.MUTED_MESSAGE_TITLE,
                            message: constants_1.AppConstants.MUTED_MESSAGE_ALL
                        });
                        _this.toggleAudio();
                    }
                }
                else {
                    if (_this.account.activeAudio) {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.MUTED_MESSAGE_TITLE,
                            message: constants_1.AppConstants.MUTED_MESSAGE
                        });
                    }
                    else {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.UNMUTED_MESSAGE_TITLE,
                            message: constants_1.AppConstants.UNMUTED_MESSAGE
                        });
                    }
                    _this.toggleAudio();
                }
                _this.disableNotification();
            }
        });
    };
    VcRoomBase.prototype._setNotificationTitleAndMessage = function (_a) {
        var title = _a.title, message = _a.message;
        this.notificationMessageTitle = title;
        this.notificationMessage = message;
    };
    VcRoomBase.prototype.subscribeToVideoOnEvents = function () {
        var _this = this;
        this.webRTC.on('signal:videoOn', function (event) {
            if (!_this.webRTC.isMyOwnConnection(event.from)) {
                if (event.data === 'broadcast') {
                    if (!_this.account.activeVideo) {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.VIDEO_ON_MESSAGE_TITLE,
                            message: constants_1.AppConstants.VIDEO_ON_MESSAGE_ALL
                        });
                        _this.toggleVideo();
                    }
                }
                else {
                    if (_this.account.activeVideo) {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.VIDEO_OFF_MESSAGE_TITLE,
                            message: constants_1.AppConstants.VIDEO_OFF_MESSAGE
                        });
                    }
                    else {
                        _this._setNotificationTitleAndMessage({
                            title: constants_1.AppConstants.VIDEO_ON_MESSAGE_TITLE,
                            message: constants_1.AppConstants.VIDEO_ON_MESSAGE
                        });
                    }
                    _this.toggleVideo();
                }
                _this.disableNotification();
            }
        });
    };
    VcRoomBase.prototype.disableNotification = function () {
        var _this = this;
        setTimeout(function () {
            _this._setNotificationTitleAndMessage({
                title: null,
                message: null
            });
        }, 5000);
    };
    VcRoomBase.prototype.subscribeToBlockEvents = function () {
        var _this = this;
        this.webRTC.on('signal:block', function (event) {
            var blockedUser = _this.vcService.vcParticipants.get(+event.data);
            if (_this.webRTC.isMyOwnConnection(blockedUser.participant.connection)) {
                _this.block.emit();
            }
            else {
                blockedUser.blocked = true;
                blockedUser.connected = false;
            }
        });
    };
    VcRoomBase.prototype.findParticipantByConnectionId = function (userInfo, connection) {
        if (userInfo.isMain) {
            return this.judge;
        }
        else if (userInfo.isStaff) {
            return this.staffParticipants.find(function (participant) { return connection.connectionId === participant.connection.connectionId; });
        }
        return this.allParticipants.find(function (participant) { return connection.connectionId === participant.connection.connectionId; });
    };
    VcRoomBase.prototype.reorderSpeakers = function (participant) {
        if (participant.isMain) {
            return;
        }
        if (participant.isStaff) {
            utils_1.reorderSpeaker(this.staffParticipants, participant, this.staffParticipantsTotalPages, this.staffParticipantsPagingStartIndex);
        }
        else {
            utils_1.reorderSpeaker(this.allParticipants, participant, this.allParticipantsTotalPages, this.participantsPagingStartIndex);
        }
    };
    VcRoomBase.prototype.setSpeakerViewData = function () {
        if (this.lastActiveParticipant !== this.activeParticipant) {
            if (this.staffParticipants[0] === this.lastActiveParticipant) {
                this.staffParticipantsTotalPages = utils_1.calculateMemberTotalPage(this.staffParticipants.length, 0, constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
                this.staffParticipantsPagingStartIndex = 0;
            }
            else if (this.allParticipants[0] === this.lastActiveParticipant) {
                this.allParticipantsTotalPages = utils_1.calculateMemberTotalPage(this.allParticipants.length, 0, constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
                this.participantsPagingStartIndex = 0;
            }
            this.lastActiveParticipant = this.activeParticipant;
        }
    };
    VcRoomBase.prototype._onFilterParticipantsInSpeakerMode = function (option) {
        var currentUserInfo = this.vcService.getUserInfo(this.account.connection['connectionProperties'].data);
        var currentUserRole = currentUserInfo.userRole || this.vcService.roles[currentUserInfo.userRoleId];
        switch (option) {
            case models_1.PARTICIPANTS_FILTER.ALL: {
                return utils_1.filterAllParticipants(this.vcParticipantsRoleMapping, currentUserRole, currentUserInfo);
            }
            case models_1.PARTICIPANTS_FILTER.BENCH_MEMBER: {
                return utils_1.filterParticipantsByUserID(this.benchMemberParticipants, currentUserInfo);
            }
            case models_1.PARTICIPANTS_FILTER.COURT_STAFF: {
                return utils_1.filterParticipantsByUserID(this.courtStaffParticipants, currentUserInfo);
            }
            default:
                return utils_1.filterParticipantsByUserID(this.otherParticipants, currentUserInfo);
        }
    };
    __decorate([
        core_1.ViewChild('commentSidebar'),
        __metadata("design:type", core_1.ElementRef)
    ], VcRoomBase.prototype, "commentSidebar", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VcRoomBase.prototype, "sessionId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], VcRoomBase.prototype, "isSubscriber", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VcRoomBase.prototype, "leave", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VcRoomBase.prototype, "end", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VcRoomBase.prototype, "block", void 0);
    return VcRoomBase;
}());
exports.VcRoomBase = VcRoomBase;
//# sourceMappingURL=vc-room-base.js.map